import { render } from "./Login.vue?vue&type=template&id=5523086a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=5523086a&scoped=true&lang=css"

import exportComponent from "/app/inventory-ui-actions-runner/_work/inventory-ui/inventory-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5523086a"]])

export default __exports__